import { useState, useCallback, useEffect } from 'react'
import {
  ReactFlow,
  applyNodeChanges,
  applyEdgeChanges,
  addEdge,
  Background,
  Controls
} from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import '@coreui/coreui/dist/css/coreui.min.css'
import { t } from 'i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import AccomodationService from '@services/accomodation.service'
import { useSpinner } from "@webkit/components/typescript/SpinnerContext"
import CardInfoNode from '@webkit/components/CardInfoNode.js'
import AccomodationNode from '@webkit/components/AccomodationNode.js'
import CardTextNode from '@webkit/components/CardTextNode.js'
import CardLinkNode from '@webkit/components/CardLinkNode.js'
import { CButton } from '@coreui/react'
import { Modal } from 'react-bootstrap'
import CardContactNode from '@webkit/components/CardContactNode.js'
import CardLocationNode from '@webkit/components/CardLocationNode.js'
import CardSuggestionNode from '@webkit/components/CardSuggestionNode.js'
import cardTextService from '@services/cardText.service'
import cardLinkService from '@services/cardLink.service'
import cardSuggestionService from '@services/cardSuggestionTransaltion.service'
import cardInfoService from '@services/cardInfo.service'
import { TYPE_CARD_ENUM } from '@webkit/enums/type-card.enum'
import { CARD_INFO_TYPE_ENUM } from '@webkit/enums/CardInfoTypeEnum.enum'
import { base64ToFile } from "@webkit/functions/utils";

export default function DashboardNodeAccomodation() {
  const [nodes, setNodes] = useState([])
  const [edges, setEdges] = useState([])
  const { showSpinner, hideSpinner } = useSpinner();
  const [selectedNode, setSelectedNode] = useState(null)

  const [showFormModal, setShowFormModal] = useState(false)

  const [formData] = useState({ label: '', description: '' })
  const navigate = useNavigate();
  const location = useLocation();
  const [nodeMap, setNodeMap] = useState({}); //mappa per recuperare i nodi della mia accomodation
  const [refreshPage, setRefreshPage] = useState(false)


  const mapNodeType = {
    "CARD_INFO": "CardInfoNode",
    "CARD_TEXT": "CardTextNode",
    "CARD_LINK": "CardLinkNode",
    "CARD_CONTACT": "CardContactNode",
    "CARD_LOCATION": "CardLocationNode",
    /* "CARD_SUGGESTION": "CardSuggestionNode", */
    "CARD_SPONSORED": "CARD_SPONSORED",
    "OTHER_HOST_ACCOMODATION": 'CardOtherHostAccomodation',
    "RECOMMENDED_BY_THE_HOST": 'CardRecommendedTheHost'
  }

  const [nodeToDelete, setNodeToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const [galleryPreviews, setGalleryPreviews] = useState(Array(10).fill(null));
  const [galleryImages, setGalleryImages] = useState(Array(10).fill(null));

  useEffect(() => {
    const recoverPhotos = async () => {
      const idAccomodation = location.pathname.split("/").at(-1);
      const results = await AccomodationService.findPhotosFromAccomodation(idAccomodation);

      // Inizializzo 10 slot vuoti
      const galleryImages = Array(10).fill(null);
      const galleryPreviews = Array(10).fill(null);

      results.slice(0, 10).forEach((photo, index) => {
        const base64Url = `data:image/png;base64,${photo.photo}`;

        // preview lato UI
        galleryPreviews[index] = base64Url;

        // file convertito per upload
        const file = base64ToFile(
          base64Url,
          photo.urlPhoto?.split('.')[0] || `photo-${index}`
        );
        galleryImages[index] = file;
      });

      setGalleryImages(galleryImages);
      setGalleryPreviews(galleryPreviews);
    };

    recoverPhotos();
  }, []);

  const handleDeleteRequest = (nodeId) => {
    setNodeToDelete(nodeId)
    setShowDeleteModal(true)
  }

  useEffect(() => {
    const initialize = async () => {

      try {
        showSpinner();
        const segments = location.pathname.split('/').filter(Boolean);
        const idAccomodation = segments.at(-1) ?? '';
        const response = await AccomodationService.getAccomodationWithAllCardTitlesById(idAccomodation);     
        if (response) {
          const { nodes: flowNodes, edges: flowEdges, map } = buildFlowData(response);
          setNodes(flowNodes);
          setEdges(flowEdges);
          setNodeMap(map);
        }
      } catch (error) {
        console.error("Errore in initialize di NewAccomodation", error);
        navigate('/');
      } finally {
        hideSpinner();
      }
    };
    initialize();
  }, [refreshPage]);

  const buildFlowData = (accomodationData) => {
    const {accomodationTranslation } = accomodationData
    const nodes = [];
    const edges = [];
    const map = {};

    const verticalSpacing = 150;
    const horizontalSpacing = 300;
    const horizontalSpacingCardInfo = 150;
    let globalY = 0; // traccia verticale globale per nodi verticali
    
    // Nodo accomodation principale
    const accomodationId = `${accomodationTranslation.accomodation.id}-${accomodationTranslation.accomodation.type}`;
    nodes.push({
      id: accomodationId,
      position: { x: -500, y: 500 },
      data: {
        title: accomodationTranslation.accomodation.name,
        address: accomodationTranslation.accomodation.fullAddress
      },
      type: "AccomodationNode",
    });
    map[accomodationId] = accomodationTranslation.accomodation;

    // Funzione ricorsiva
    const traverse = (node, parentId = null, depth = 0, offsetX = 0, baseY = null) => {
      const nodeId = `n${node.id}-${node.type}`;
      const x = offsetX;
      const y = baseY !== null ? baseY : globalY * verticalSpacing;

      if (node.type !== mapNodeType.CARD_SPONSORED) {
        // Inserimento nodo
        nodes.push({
          id: nodeId,
          position: { x, y },
          data: { node, parentId },
          type: mapNodeType[node.type],
        });
        map[nodeId] = node;

        // Creazione edge verso il padre
        if (parentId) edges.push({ id: `${parentId}-${nodeId}`, source: parentId, target: nodeId, selectable: false });
        else edges.push({ id: `${accomodationId}-${nodeId}`, source: accomodationId, target: nodeId, selectable: false });

        // Incrementa globalY se il nodo è verticale
        if ([TYPE_CARD_ENUM.CARD_INFO,
        TYPE_CARD_ENUM.CARD_CONTACT,
        TYPE_CARD_ENUM.CARD_LOCATION,
        CARD_INFO_TYPE_ENUM.RECOMMENDED_BY_THE_HOST,
        CARD_INFO_TYPE_ENUM.OTHER_HOST_ACCOMODATION].includes(node.type)) {
          globalY++;
        }

        // Separazione figli
        const verticalChildren = node.children?.filter(c =>
          [TYPE_CARD_ENUM.CARD_INFO,
          TYPE_CARD_ENUM.CARD_CONTACT,
          TYPE_CARD_ENUM.CARD_LOCATION,
          CARD_INFO_TYPE_ENUM.RECOMMENDED_BY_THE_HOST,
          CARD_INFO_TYPE_ENUM.OTHER_HOST_ACCOMODATION].includes(c.type)
        ) || [];

        const horizontalChildren = node.children?.filter(c =>
          ![TYPE_CARD_ENUM.CARD_INFO,
          TYPE_CARD_ENUM.CARD_CONTACT,
          TYPE_CARD_ENUM.CARD_LOCATION,
          CARD_INFO_TYPE_ENUM.RECOMMENDED_BY_THE_HOST,
          CARD_INFO_TYPE_ENUM.OTHER_HOST_ACCOMODATION].includes(c.type)
        ) || [];

        // Figli verticali → ricorsione verticale con incremento automatico y
        verticalChildren.forEach((child) => {
          traverse(child, nodeId, depth + 1, x + horizontalSpacingCardInfo);
        });

        // Figli orizzontali → stessa altezza del padre, spostamento solo in x
        horizontalChildren.forEach((child, idx) => {
          traverse(child, nodeId, depth + 1, x + (idx + 1) * horizontalSpacing, y);
        });
      }
    };

    // Avvio ricorsione sui root node dell’accomodation
    accomodationData.children.forEach((rootNode) => {
      const accomodationNodeId = `${accomodationTranslation.accomodation.id}-${accomodationTranslation.accomodation.type}`;
      traverse(rootNode, accomodationNodeId, 0, 0);
    });

    return { nodes, edges, map };
  };

  // Gestione della posizione degli handle sulle cardInfo, l'handle può essere in posizione in basso o a destra
  const handlePosition = (node) => {
    const children = node.children || [];

    const hasCardInfoChild = children.some(c => c.type === TYPE_CARD_ENUM.CARD_INFO
      || c.type === TYPE_CARD_ENUM.CARD_CONTACT
      || c.type === TYPE_CARD_ENUM.CARD_LOCATION
      || c.type === CARD_INFO_TYPE_ENUM.RECOMMENDED_BY_THE_HOST
      || c.type === CARD_INFO_TYPE_ENUM.OTHER_HOST_ACCOMODATION); // se anche questi sono verticali
    const hasOtherChild = children.some(c => ![TYPE_CARD_ENUM.CARD_INFO,
    TYPE_CARD_ENUM.CARD_CONTACT,
    TYPE_CARD_ENUM.CARD_LOCATION,
    CARD_INFO_TYPE_ENUM.RECOMMENDED_BY_THE_HOST,
    CARD_INFO_TYPE_ENUM.OTHER_HOST_ACCOMODATION].includes(c.type));

    if (hasCardInfoChild) return 'bottom';
    if (hasOtherChild) return 'right';
  };

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    []
  )
  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    []
  )
  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    []
  )

  const nodeTypes = {
    AccomodationNode: (props) => <AccomodationNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest,
      galleryPreviews,
      galleryImages,
      setGalleryPreviews,
      setGalleryImages
    }} />, // chiave = stringa, valore = componente
    CardInfoNode: (props) => <CardInfoNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest,
      handlePosition: handlePosition(props.data.node)
    }} />,
    CardTextNode: (props) => <CardTextNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest,
    }} />,
    CardLinkNode: (props) => <CardLinkNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest
    }} />,
    CardContactNode: (props) => <CardContactNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest
    }} />,
    CardLocationNode: (props) => <CardLocationNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest
    }} />,
    CardSuggestionNode: (props) => <CardSuggestionNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest
    }} />,
    CardOtherHostAccomodation: (props) => <CardInfoNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest,
      handlePosition: handlePosition(props.data.node)
    }} />,
    CardRecommendedTheHost: (props) => <CardInfoNode {...props} data={{
      ...props.data,
      onDelete: handleDeleteRequest,
      handlePosition: handlePosition(props.data.node)
    }} />,
  };

  // TODO - metodo aggiunto per creare un nuovo nodo direttamente sulla pagina
  const handleAddNode = () => {
    if (!selectedNode) return

    const childNodes = nodes.filter((n) =>
      edges.some((e) => e.source === selectedNode.id && e.target === n.id)
    )

    const xOffset = 200
    const newX =
      selectedNode.position.x + (childNodes.length + 1) * xOffset
    const newY = selectedNode.position.y


    const newNodeId = `n${nodes.length + 1}`
    const newNode = {
      id: newNodeId,
      position: { x: newX, y: newY },
      data: { label: formData.label, description: formData.description },
      type: "",
    }

    const newEdge = {
      id: `${selectedNode.id}-${newNodeId}`,
      source: selectedNode.id,
      target: newNodeId,
    }

    setNodes((prev) => [...prev, newNode])
    setEdges((prev) => [...prev, newEdge])

    setShowFormModal(false)
    setSelectedNode(null)
  };

  const confirmDeleteNode = async () => {
    if (!nodeToDelete) return

    const node = nodes.find((nod) => nod.id == nodeToDelete)
    if (!node) return null
    const { data, type } = node

    // rimuove il nodo
    setNodes((nds) => nds.filter((n) => n.id !== nodeToDelete))

    // rimuove tutti gli edge collegati
    setEdges((eds) =>
      eds.filter((e) => e.source !== nodeToDelete && e.target !== nodeToDelete)
    )

    // pulizia stato
    setNodeToDelete(null)
    setShowDeleteModal(false)

    showSpinner()
    try {
      const { node } = data
      let response
      switch (type) {
        case mapNodeType.CARD_INFO:
          response = await cardInfoService.deleteCardInfo(node.id)
          return
        
        case mapNodeType.RECOMMENDED_BY_THE_HOST:
          response = await cardInfoService.deleteCardInfo(node.id)
          return

        case mapNodeType.CARD_TEXT:
          response = await cardTextService.deleteCardText(node.id)
          return

        case mapNodeType.CARD_LINK:
          response = await cardLinkService.deleteCardLink(node.id)
          return

        /* case mapNodeType.CARD_SUGGESTION:
          response = await cardSuggestionService.deleteCardSuggestion(node.id)
          return */

        default:
          alert(t("error.undeletable_node"))
      }
    } catch (error) {
      console.log(error);
    } finally {
      setRefreshPage(!refreshPage)
      setTimeout(() => hideSpinner(), 2000)
    }
  }

  const cancelDeleteNode = () => {
    setNodeToDelete(null)
    setShowDeleteModal(false)
  }

  return (
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      <h1 style={{ color: '#00BFA6' }}>{t('title.create_hostyble')}</h1>
      <p>{t("page_description.node_accomodation")}</p>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        nodeTypes={nodeTypes}
        style={{ borderRadius: '25px' }}
        nodesConnectable={false}
        deleteKeyCode={null}
      >
        <Background />
        <Controls />
      </ReactFlow>
      {/* Modale di conferma eliminazione */}
      <Modal show={showDeleteModal} onHide={cancelDeleteNode} alignment='center'
        centered>
        <Modal.Body>
          <p>{t('text.sure_delete_card')}</p>
        </Modal.Body>
        <Modal.Footer>
          <CButton color="secondary" onClick={cancelDeleteNode} style={{ borderRadius: '15px' }}>
            {t('button.cancel')}
          </CButton>
          <CButton color="danger text-white" onClick={confirmDeleteNode} style={{ borderRadius: '15px' }}>
            {t('button.delete')}
          </CButton>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
